import http from './http'

// 获取列表
export function pageList (queryString) {
  return http.post(`/client/user/feedback/pagelist`, queryString)
}
